/* ============================================================
   X-BIOAGE Cart Drawer — Vanilla JS, Section Rendering API
   ============================================================ */
(function() {
  'use strict';

  var SECTION_ID = 'xb-cart-drawer';
  var DRAWER_SELECTOR = '[data-xb-drawer]';

  var XbCart = {
    el: null,
    autoCloseTimer: null,

    init: function() {
      this.el = document.querySelector(DRAWER_SELECTOR);
      if (!this.el) return;

      // Cart icon toggles — both desktop and mobile
      document.addEventListener('click', this._onDocClick.bind(this));
      document.addEventListener('keydown', this._onKeyDown.bind(this));
      // Quantity input: debounced change handler
      document.addEventListener('input', this._onInput.bind(this));

      // Touch swipe-to-close (mobile only)
      this._bindSwipe();

      // Initial check: hide top announcement bar if cart already ≥ €150
      this._refreshCartBubble();
    },

    _bindSwipe: function() {
      var panel = this.el.querySelector('[data-xb-drawer-panel]');
      if (!panel) return;
      var startX = 0, startY = 0, startT = 0, dx = 0, dragging = false;
      var self = this;

      panel.addEventListener('touchstart', function(e) {
        if (window.innerWidth >= 750) return;
        var t = e.touches[0];
        startX = t.clientX; startY = t.clientY; startT = Date.now();
        dx = 0; dragging = false;
      }, { passive: true });

      panel.addEventListener('touchmove', function(e) {
        if (window.innerWidth >= 750) return;
        var t = e.touches[0];
        var dxNow = t.clientX - startX;
        var dyNow = t.clientY - startY;
        if (!dragging) {
          if (dxNow > 8 && Math.abs(dyNow) < 12) {
            dragging = true;
            panel.classList.add('is-dragging');
          } else if (Math.abs(dyNow) > 12) {
            // Vertical scroll wins — give up
            startX = -9999;
          }
        }
        if (dragging) {
          dx = Math.max(0, dxNow);
          panel.style.transform = 'translateX(' + dx + 'px)';
        }
      }, { passive: true });

      panel.addEventListener('touchend', function() {
        if (!dragging) return;
        var dt = Date.now() - startT;
        var velocity = dx / Math.max(1, dt); // px/ms
        panel.classList.remove('is-dragging');
        panel.style.transform = '';
        if (dx > 80 || velocity > 0.5) {
          self.close();
        }
        dragging = false; dx = 0;
      });
    },

    _onDocClick: function(e) {
      var t = e.target;
      // Open drawer when user clicks any cart toggle
      var toggle = t.closest && t.closest('.ajax-cart__toggle, [data-xb-cart-toggle], a[href="' + (window.routes && window.routes.cart_url ? window.routes.cart_url : '/cart') + '"], a[href="/cart"]');
      if (toggle) {
        // Don't intercept if user wants to see the cart page (modifier keys / middle-click)
        if (e.metaKey || e.ctrlKey || e.shiftKey || e.button === 1) return;
        e.preventDefault();
        this.open();
        return;
      }
      // Close on backdrop / close button
      if (t.closest && t.closest('[data-xb-drawer-close]')) {
        e.preventDefault();
        this.close();
        return;
      }
      // Quantity +/- buttons
      var qtyBtn = t.closest && t.closest('[data-xb-qty-change]');
      if (qtyBtn) {
        e.preventDefault();
        var change = parseInt(qtyBtn.dataset.xbQtyChange, 10);
        var input = qtyBtn.parentElement.querySelector('[data-xb-qty-input]');
        if (!input) return;
        var current = parseInt(input.value, 10) || 0;
        var next = Math.max(0, current + change);
        this.changeQty(input.dataset.itemKey, next);
        return;
      }
      // Remove item
      var removeBtn = t.closest && t.closest('[data-xb-item-remove]');
      if (removeBtn) {
        e.preventDefault();
        var itemEl = removeBtn.closest('[data-xb-item]');
        if (!itemEl) return;
        this.removeItem(itemEl.dataset.itemKey, itemEl);
        return;
      }
    },

    _onKeyDown: function(e) {
      if (e.key === 'Escape' && this.isOpen()) this.close();
    },

    _onInput: function(e) {
      var t = e.target;
      if (t.matches && t.matches('[data-xb-qty-input]')) {
        // Debounce per input
        if (t._xbDebounce) clearTimeout(t._xbDebounce);
        t._xbDebounce = setTimeout(function() {
          var qty = parseInt(t.value, 10);
          if (isNaN(qty) || qty < 0) qty = 0;
          XbCart.changeQty(t.dataset.itemKey, qty);
        }, 350);
      }
    },

    isOpen: function() {
      return this.el && this.el.getAttribute('data-open') === 'true';
    },

    open: function() {
      if (!this.el) return;
      if (this.isOpen()) return;
      // iOS-safe scroll lock: pin body in place
      var scrollY = window.scrollY || window.pageYOffset || 0;
      document.body.dataset.xbScrollLock = String(scrollY);
      document.body.style.position = 'fixed';
      document.body.style.top = '-' + scrollY + 'px';
      document.body.style.left = '0';
      document.body.style.right = '0';
      document.body.style.width = '100%';
      this.el.setAttribute('data-open', 'true');
      this.el.setAttribute('aria-hidden', 'false');
      document.body.classList.add('xb-drawer-open');
    },

    close: function() {
      if (!this.el) return;
      this.el.setAttribute('data-open', 'false');
      this.el.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('xb-drawer-open');
      // Restore scroll position
      var savedY = parseInt(document.body.dataset.xbScrollLock || '0', 10);
      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.left = '';
      document.body.style.right = '';
      document.body.style.width = '';
      delete document.body.dataset.xbScrollLock;
      if (savedY > 0) window.scrollTo(0, savedY);
      this._clearAutoClose();
    },

    /** Refresh drawer content via Section Rendering API */
    refresh: function(opts) {
      opts = opts || {};
      var oldKeys = opts.oldKeys || {};
      var self = this;
      // Fetch from the localized storefront root (e.g. /de-it/) so the re-rendered
      // drawer keeps the active language; '/' would always return the primary locale.
      var xbRoot = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      return fetch(xbRoot + '?sections=' + SECTION_ID, { credentials: 'same-origin' })
        .then(function(r) {
          if (!r.ok) throw new Error('[XbCart] fetch ' + r.status);
          return r.json();
        })
        .then(function(sections) {
          var html = sections[SECTION_ID];
          if (!html) throw new Error('No section content');
          // Parse the section HTML and find the inner drawer panel
          var tmp = document.createElement('div');
          tmp.innerHTML = html;
          var newPanel = tmp.querySelector('[data-xb-drawer-panel]');
          var currentPanel = self.el.querySelector('[data-xb-drawer-panel]');
          if (newPanel && currentPanel) {
            // Capture old subtotal for flip detection
            var oldSubEl = currentPanel.querySelector('[data-xb-subtotal]');
            var oldSubText = oldSubEl ? oldSubEl.textContent : null;
            currentPanel.innerHTML = newPanel.innerHTML;
            // A5: Subtotal flip if changed
            var newSubEl = currentPanel.querySelector('[data-xb-subtotal]');
            if (newSubEl && oldSubText !== null && newSubEl.textContent !== oldSubText) {
              newSubEl.classList.add('xb-flip');
              setTimeout(function() { newSubEl.classList.remove('xb-flip'); }, 420);
            }
            // Mark fresh items (qty increased vs snapshot)
            if (opts.markFresh) {
              currentPanel.querySelectorAll('[data-xb-item]').forEach(function(itemEl) {
                var key = itemEl.dataset.itemKey;
                var newQtyInput = itemEl.querySelector('[data-xb-qty-input]');
                var newQty = newQtyInput ? parseInt(newQtyInput.value, 10) : 0;
                if (newQty > (oldKeys[key] || 0)) {
                  itemEl.classList.add('xb-item-fresh');
                }
              });
            }
            // Update header cart bubble visibility
            self._refreshCartBubble();
            // Re-run inline scripts within the new content (e.g. RALE consent app injection)
            currentPanel.querySelectorAll('script').forEach(function(oldS) {
              try {
                var s = document.createElement('script');
                if (oldS.src) s.src = oldS.src; else s.textContent = oldS.textContent;
                oldS.parentNode.replaceChild(s, oldS);
              } catch (e) { console.warn('[XbCart] script re-inject failed', e); }
            });
            // Re-init RALE Terms & Conditions widget if loaded
            if (window.roarJs && window.roarJs.Legal && typeof window.roarJs.Legal.refresh === 'function') {
              try { window.roarJs.Legal.refresh(); } catch (e) {}
            }
          }
        })
        .catch(function(err) { console.warn('[XbCart] refresh failed', err); });
    },

    _refreshCartBubble: function() {
      fetch('/cart.js', { credentials: 'same-origin' })
        .then(function(r) { return r.json(); })
        .then(function(cart) {
          document.querySelectorAll('.site-header__cart-bubble').forEach(function(b) {
            b.classList.toggle('site-header__cart-bubble--visible', cart.item_count > 0);
          });
          XbCart._updateShippingBanner(cart);
        })
        .catch(function() {});
    },

    /** Hide top announcement bar when free-shipping threshold (€150) reached */
    _updateShippingBanner: function(cart) {
      var THRESHOLD = 15000; // cents
      var reached = cart && cart.total_price >= THRESHOLD;
      document.querySelectorAll('.announcement-bar').forEach(function(bar) {
        bar.classList.toggle('announcement-bar--hidden', reached);
      });
    },

    /** Add product to cart (from product page form) */
    addItem: function(form) {
      var self = this;
      // Snapshot current cart for fresh-item detection
      return fetch('/cart.js', { credentials: 'same-origin' })
        .then(function(r) {
          if (!r.ok) throw new Error('[XbCart] cart.js ' + r.status);
          return r.json();
        })
        .then(function(oldCart) {
          var oldKeys = {};
          (oldCart.items || []).forEach(function(it) { oldKeys[it.key] = it.quantity; });
          var formData = new FormData(form);
          return fetch('/cart/add.js', {
            method: 'POST',
            credentials: 'same-origin',
            headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
            body: formData
          }).then(function(r) {
            if (!r.ok) throw new Error('add.js HTTP ' + r.status);
            return r.json();
          }).then(function() {
            return self.refresh({ markFresh: true, oldKeys: oldKeys });
          }).then(function() {
            self.open();
            self._scheduleAutoClose(2500);
          });
        });
    },

    changeQty: function(key, qty) {
      if (!key) return;
      var itemEl = this.el && this.el.querySelector('[data-item-key="' + key + '"]');
      if (itemEl && itemEl.classList) itemEl.classList.add('is-updating');
      var self = this;
      return fetch('/cart/change.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: key, quantity: qty })
      })
        .then(function(r) {
          if (!r.ok) throw new Error('[XbCart] change.js ' + r.status);
          return r.json();
        })
        .then(function() { return self.refresh(); })
        .catch(function(err) { console.warn('[XbCart] change failed', err); });
    },

    removeItem: function(key, itemEl) {
      if (!key) return;
      var self = this;
      if (itemEl) itemEl.classList.add('is-removing');
      // Wait for slide-out animation, then send delete + refresh
      setTimeout(function() {
        self.changeQty(key, 0);
      }, 300);
    },

    _scheduleAutoClose: function(ms) {
      this._clearAutoClose();
      var self = this;
      this.autoCloseTimer = setTimeout(function() { self.close(); }, ms);
      // Cancel if user interacts with drawer
      var cancel = function() { self._clearAutoClose(); };
      var panel = this.el.querySelector('[data-xb-drawer-panel]');
      if (panel) {
        panel.addEventListener('mouseenter', cancel, { once: true });
        panel.addEventListener('touchstart', cancel, { once: true, passive: true });
        panel.addEventListener('click', cancel, { once: true });
      }
    },

    _clearAutoClose: function() {
      if (this.autoCloseTimer) { clearTimeout(this.autoCloseTimer); this.autoCloseTimer = null; }
    }
  };

  window.XbCart = XbCart;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() { XbCart.init(); });
  } else {
    XbCart.init();
  }
})();
